import {
  SideMenuHeader,
  SideMenuHeaderIcon,
  SideMenuHeaderSubTitle,
  SideMenuHeaderTitle,
  SideMenuHeaderTitleText,
  SideMenuItem,
  SideMenuItems,
  SideMenuSubItem,
  SideMenuSubItemContent,
  SideMenuSubItems
} from './SideMenu.styled';
import React, { ReactNode } from 'react';

export interface ISideMenuSubItem {
  id: string;
  selected?: boolean;
  subItemComponent?: ReactNode;
  onClick?: () => void;
}

export interface ISideMenuItem {
  id: string;
  title: ReactNode;
  subtitle?: ReactNode;
  icon?: ReactNode;
  defaultExpanded?: boolean;
  subItems?: ISideMenuSubItem[];
}

export interface ISideMenuProps {
  items: ISideMenuItem[];
}

export const SideMenu = ({ items = [] }: ISideMenuProps): JSX.Element => (
  <SideMenuItems>
    {items.map(({ id, title, subtitle, icon, defaultExpanded, subItems }) => (
      <SideMenuItem key={id} defaultExpanded={defaultExpanded}>
        <SideMenuHeader aria-controls={id} id={id}>
          <SideMenuHeaderTitle>
            {icon && <SideMenuHeaderIcon>{icon}</SideMenuHeaderIcon>}

            <SideMenuHeaderTitleText>{title}</SideMenuHeaderTitleText>
          </SideMenuHeaderTitle>

          <SideMenuHeaderSubTitle>{subtitle}</SideMenuHeaderSubTitle>
        </SideMenuHeader>

        {subItems ? (
          <SideMenuSubItems>
            {subItems.map(({ id: subItemId, selected = false, onClick, subItemComponent }) => (
              <SideMenuSubItem key={subItemId} selected={selected}>
                <SideMenuSubItemContent onClick={onClick}>{subItemComponent}</SideMenuSubItemContent>
              </SideMenuSubItem>
            ))}
          </SideMenuSubItems>
        ) : null}
      </SideMenuItem>
    ))}
  </SideMenuItems>
);
